import React, { useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import { motion, useInView } from "framer-motion";

import AgriOne from "../assets/images/Agri-one.png";
import AgriTwo from "../assets/images/Agri-three.png";

import "../assets/styles/HeroSection.css";

// Variants for text and images
const textVariants = {
  hidden: { x: -50, opacity: 0, filter: "blur(10px)" },
  visible: {
    x: 0,
    opacity: 1,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: "easeOut", delay: 0.2 },
  },
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.9, filter: "blur(10px)" },
  visible: {
    opacity: 1,
    scale: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: "easeOut",
      delay: 0.4,
      type: "spring",
      stiffness: 100,
    },
  },
};

const AgricultureSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { margin: "-100px" });

  return (
    <Box
      ref={sectionRef}
      sx={{ backgroundColor: "#1A1A1A", color: "white" }}
      className="padding-around"
    >
      <Box
        sx={{
          backgroundColor: "#1A1A1A",
          color: "white",
          borderRadius: 2,
          mt: 5,
          mb: 5,
        }}
      >
        <Grid container spacing={2} alignItems="stretch">
          {/* Full-width Text */}
          <Grid item xs={12}>
            <motion.div
              variants={textVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
            >
              {/* <Typography className="premium-heading" sx={{ mb: 2, p: 2 }}>
                We Bring You Premium Agricultural Products Cultivated By
                Communities Across Africa, Asia, And Beyond, Rooted In
                Sustainability And Tradition.
              </Typography> */}
            </motion.div>
          </Grid>

          {/* Left Image (6 columns) */}
          <Grid item xs={12} md={8}>
            <motion.div
              variants={imageVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
            >
              <Box sx={{ height: 360 }}>
                <img
                  src={AgriOne}
                  alt="Farming 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 12,
                  }}
                />
              </Box>
            </motion.div>
          </Grid>

          {/* Right Image (6 columns) */}
          <Grid item xs={12} md={4}>
            <motion.div
              variants={imageVariants}
              initial="hidden"
              animate={isInView ? "visible" : "hidden"}
            >
              <Box sx={{ height: 360 }}>
                <img
                  src={AgriTwo}
                  alt="Farming 2"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 12,
                  }}
                />
              </Box>
            </motion.div>
          </Grid>

          {/* Full-width Image Below */}
       
        </Grid>
      </Box>
    </Box>
  );
};

export default AgricultureSection;
